<template>
  <label class="ds-switch">
    <input
      type="checkbox"
      :checked="value"
      :disabled="disabled"
      :aria-label="ariaLabel"
      @change="$emit('change', $event.target.checked)"
    >
    <span class="ds-switch-track">
      <span class="ds-switch-knob" />
    </span>
  </label>
</template>

<script>
export default {
  name: 'DsSwitch',
  // So v-model works, not just :value + @change.
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    ariaLabel: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped lang="scss">
@import '~@/design-system/mixins';

// Switch geometry. The inset is the gap around the circle; deriving the travel from it
// keeps the knob inside the pill however these are tuned.
$switch-w: 48px;
$switch-h: 28px;
$switch-inset: 4px;
$switch-knob: $switch-h - ($switch-inset * 2);
$switch-travel: $switch-w - ($switch-inset * 2) - $switch-knob;

.ds-switch {
  flex-shrink: 0;
  margin: 0;
  cursor: pointer;
  line-height: 0;

  input {
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;
  }
}

.ds-switch-track {
  display: flex;
  align-items: center;
  width: $switch-w;
  height: $switch-h;
  padding: $switch-inset;
  border-radius: 999px;
  background: $c-border;
  transition: background 0.18s ease;
  // Guarantees the circle and its shadow stay inside the pill.
  overflow: hidden;
}

.ds-switch-knob {
  width: $switch-knob;
  height: $switch-knob;
  flex: 0 0 auto;
  border-radius: 999px;
  background: $c-white;
  box-shadow: 0 1px 2px rgba($c-wine, 0.2);
  transition: transform 0.18s ease;
}

.ds-switch input:checked + .ds-switch-track {
  background: $c-orange;
}

.ds-switch input:checked + .ds-switch-track .ds-switch-knob {
  transform: translateX($switch-travel);
}

.ds-switch input:focus-visible + .ds-switch-track {
  box-shadow: 0 0 0 3px rgba($c-orange, 0.28);
}

.ds-switch input:disabled + .ds-switch-track {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
